import { ColumnData } from './column-data';
import { DateRange, FilterBy, ReportType, ReportStatus } from './reports.constants';

export class Report {
    public columns: ColumnData[];
    public companyRoleId: number;
    public createdDate: string;
    public dateRange: DateRange;
    public dateRangeDisplay: string;
    public description: string;
    public enableFooterTotals: boolean;
    public endDate: string;
    public filterBy: FilterBy;
    public id: number;
    public isGlobal: boolean;
    public lastRun: string;
    public modifiedDate: string;
    public name: string;
    public reportType: ReportType;
    public sort: ReportSort[];
    public startDate: string;
    public status: ReportStatus;
    public userName: string;

    constructor(obj?: Partial<Report>) {
        this.columns = obj?.columns || [];
        this.companyRoleId = obj?.companyRoleId || 2;
        this.createdDate = obj?.createdDate || null;
        this.dateRange = obj?.dateRange || null;
        this.dateRangeDisplay = obj?.dateRangeDisplay;
        this.description = obj?.description || null;
        this.enableFooterTotals = obj?.enableFooterTotals || false;
        this.endDate = obj?.endDate || null;
        this.filterBy = obj?.filterBy || null;
        this.id = obj?.id || 0;
        this.isGlobal = obj?.isGlobal || false;
        this.lastRun = obj?.lastRun || null;
        this.modifiedDate = obj?.modifiedDate || null;
        this.name = obj?.name || null;
        this.reportType = obj?.reportType || null;
        this.sort = obj?.sort || [];
        this.startDate = obj?.startDate || null;
        this.status = obj?.status || ReportStatus.All;
        this.userName = obj?.userName || null;
    }
}

export class ReportSort {
    public fieldName: string;
    public direction: string;

    constructor(obj?: Partial<ReportSort>) {
        this.fieldName = obj?.fieldName || 'name';
        this.direction = obj?.direction || 'asc';
    }
}
